/**
 * Teams panel - no data processing. Implementation may be in Sidebar/PHP.
 */
import { BasePanel } from "./BasePanel";
import type { PanelContainer } from "./BasePanel";

export class TeamsPanel extends BasePanel {
    private _container: ReturnType<typeof window.jQuery> | null = null;

    getId(): string {
        return "team";
    }

    getContainer(): PanelContainer {
        if (!this._container) {
            this._container = window.jQuery("#construkted-popup-team");
        }

        return this._container;
    }
}
